import { Check, ArrowUpRight } from "lucide-react";
import { SERVICES, scrollToId } from "@/data/content";
import { Reveal } from "@/components/Reveal";

const ServiceCard = ({ service, onSelect, large }) => (
  <article
    data-testid={`service-card-${service.id}`}
    className={`group relative flex flex-col overflow-hidden rounded-[1.75rem] border border-slate-100 bg-white shadow-[0_4px_24px_rgba(15,23,42,0.05)] transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_60px_rgba(0,179,107,0.14)] ${
      large ? "lg:col-span-2" : ""
    }`}
  >
    <div className={`relative overflow-hidden ${large ? "h-60 sm:h-72" : "h-52"}`}>
      <img
        src={service.image}
        alt={service.title}
        loading="lazy"
        className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
      />
      <span className="absolute left-4 top-4 rounded-full bg-white/85 px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-widest text-[#009E5E] backdrop-blur-md">
        {service.badge}
      </span>
    </div>
    <div className="flex flex-1 flex-col p-6 sm:p-7">
      <h3 className="text-xl font-bold tracking-tight text-slate-900 sm:text-2xl">
        {service.title}
      </h3>
      <p className="mt-2.5 text-sm leading-relaxed text-slate-600">{service.description}</p>
      <ul className="mt-4 space-y-2">
        {service.features.map((f) => (
          <li key={f} className="flex items-start gap-2.5 text-sm text-slate-600">
            <Check className="mt-0.5 h-4 w-4 shrink-0 text-[#00B36B]" />
            {f}
          </li>
        ))}
      </ul>
      <button
        data-testid={`service-quote-${service.id}`}
        onClick={() => {
          onSelect(service.id);
          scrollToId("contatti");
        }}
        className="mt-6 inline-flex w-fit items-center gap-1.5 rounded-full border border-[#00B36B]/30 px-5 py-2.5 text-sm font-bold text-[#009E5E] transition-all duration-300 hover:bg-[#00B36B] hover:text-white"
      >
        Richiedi preventivo
        <ArrowUpRight className="h-4 w-4" />
      </button>
    </div>
  </article>
);

const ServicesGrid = ({ onSelectService }) => (
  <section id="servizi" className="bg-[#F9FAFB] py-20 lg:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#009E5E]">
          I nostri servizi
        </span>
        <h2 className="mt-3 max-w-2xl text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
          Un unico partner per ogni ambiente,{" "}
          <span className="font-serif-accent font-medium text-[#00B36B]">ovunque in Italia</span>
        </h2>
        <p className="mt-4 max-w-2xl text-base leading-relaxed text-slate-600">
          Programmi di pulizia ordinaria e straordinaria, con capitolato tecnico trasparente e
          squadre dedicate in tutte le regioni.
        </p>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {SERVICES.map((s, i) => (
          <Reveal key={s.id} delay={(i % 3) * 0.1} className={i === 0 ? "lg:col-span-2" : ""}>
            <ServiceCard service={s} onSelect={onSelectService} large={i === 0} />
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default ServicesGrid;
